import React from "react";

export const CallforSponsors = () => {
  return (
    <div className="visa-big-box container">
      <h3>Why Support IHCI 2023?</h3>
      <ul style={{ padding: "0" }}>
        <li>
          Advertise your products to potential users/customers, as well as
          potential innovation partners.
        </li>
        <li>
          Showcase your company as an exciting place to work and attract highly
          qualified individuals. Post your job openings directly on the IHCI
          webpage!
        </li>
        <li>
          IHCI attracts recognized experts, as well as promising young
          researchers and skilled computer scientists. Your advertisements
          and/or job announcements provide direct access to potential candidates
          for your open positions.
        </li>
        <li>
          Support the transfer of knowledge and innovation from academia to
          industry and the general public.
        </li>
        <li>
          IHCI offers the public access to cutting-edge developments and
          innovative ideas in the field. Sponsoring IHCI creates a direct
          association between innovation in Computing & Software and your
          business.
        </li>
        <li>
          Support student presentations, travel grants, and awards as a
          prestigious soft-power R&D ecosystem with strong connections to local
          and global HCI research and industry.
        </li>
      </ul>
      <hr className="hr-style" />
    </div>
  );
};
